// src/components/UniversalSearch.js
import React, { useState, useRef, useEffect } from 'react';
import { TextField, Button, Box, CircularProgress, Typography } from '@mui/material';

const UniversalSearch = ({ onSearch, title, placeholder }) => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    // Automatically focus the input field when the component mounts
    // This is key for the barcode scanner functionality
    inputRef.current.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!query) return;
    setLoading(true);
    await onSearch(query);
    setLoading(false);
    setQuery(''); // Clear input after search for quick re-scanning
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" gutterBottom>{title}</Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Click the field and scan a barcode, or type a name, email, country, or form number and press Enter.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', gap: 2 }}>
        <TextField
          inputRef={inputRef}
          fullWidth
          label={placeholder}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          variant="outlined"
        />
        <Button type="submit" variant="contained" disabled={loading} sx={{ minWidth: 120 }}>
          {loading ? <CircularProgress size={24} /> : 'Search'}
        </Button>
      </Box>
    </Box>
  );
};

export default UniversalSearch;